<div class="complete-page">
  <div class="complete-page-inner">
    <span class="completed-page-check material-icons">check_circle</span>
    <h2>Uw reparatie is aangemeld!</h2>
    <div class="step-content-label">Nog een reparatie aanmelden? Start dan <a href="/">hier</a> opnieuw.</div>
  </div>
</div>
